export default {
    methods: {
        resetZoom() {
            this.chart.resetZoom();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/resetChart.js